
import { UgcVO } from "@/views/biz/ugc/vo/ugc.vo";
import axios from "axios";
import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
import BottomSheets from "@/components/BottomSheets.vue";
import UgcReportForm from "@/components/UgcReportForm.vue";

@Component({
  components: {BottomSheets, UgcReportForm}
})
export default class UgcProfile extends Vue {
  @Prop()
  ugcTypeCd!: string;
  @PropSync('propUgc')
  ugc!: UgcVO;
  @Prop({default: false})
  isDetail!: boolean;
  

  // UGC 삭제
  deleteUgc() {
    if(this.ugc.isMyUgc && this.ugc.boardTypeCd == '055005' && this.ugc.isSelected == true) {
      // 답변이 채택된 게시글은 삭제할 수 없습니다.
      alert(this.$t('ugc.a0013'));
      return;
    }

    // c0004": 게시물을 삭제하면 포인트가 회수됩니다. 계속하시겠습니까?
    if (confirm(this.$t("review.c0004").toString()) == false) {
      return;
    }

    BottomSheets.closeAll();

    axios.delete("/ugc", { data: this.ugc }).then((r) => {
      if (r.data) {
        // 삭제되었습니다.
        alert(this.$t("review.a0019"));
        this.blindUgc();
        this.isDetail && this.$router.go(-1);
      }
    });
  }

  // UGC 수정
  modifyUgc(params: {}) {
    if(this.ugc.isMyUgc && this.ugc.boardTypeCd == '055005' && this.ugc.isSelected == true) {
      // 답변이 채택된 게시글은 수정할 수 없습니다.
      alert(this.$t('ugc.a0012'));
      return;
    }

    this.$router.push(params);
  }

  // 신고하기 콜백
  reportCallback(r: any, targetCd: number) {
    // 아무작업도 안했을 때
    if (r == null) {
      return;
    }

    // 접수 되었습니다.
    alert(this.$t("review.a0005").toString());

    // 1: 신고 게시물 비공개 처리, 0: 신고 접수만 완료
    if (r.data) {
      this.blindUgc();

      this.isDetail && this.$router.go(-1);
    }
  }

  //(언)팔로우
  follow() {
    const params = { targetCd: this.ugc.memCd, ugcTypeCd: "047003" };
    // 팔로우
    if (this.ugc.isMyFollow == false) {
      axios.post("/ugc/follow", params).then((r) => {
        return this.followCallback();
      });
      return;
    }
    // 언팔로우
    axios.delete("/ugc/follow", { params }).then((r) => {
      return this.followCallback();
    });
  }

  
  // 팔로우 콜백
  followCallback() {
    this.ugc.isMyFollow = !this.ugc.isMyFollow;
  }

  // 사용자 신고
  hideUgcsByMemCd() {
    // 선택한 사용자의 게시물이 목록에서 제외됩니다. 진행하시겠습니까?
    if (confirm(this.$t("feed.c0001").toString()) == false) {
      return;
    }
    // 047001: 리뷰, 047002: 피드, 047003: 사용자'
    axios.post("/ugc/report", { ugcTypeCd: "047003", targetCd: this.ugc.memCd }).then(() => {
      this.blindUgc();
      BottomSheets.closeAll();
    });
  }

  // 게시물 가림(삭제 또는 신고만)
  blindUgc() {
    this.$set(this.ugc, "isBlind", true);
    this.$store.commit("touchKeepAlive");
  }

}
